<template>
  <div class="public-info-wrapper">
    <div class="consultant-profile-container" v-animate-css="'fadeIn'">
      <div class="consultant-profile-header">
        <div class="section-title">Public information</div>
        <div class="consultant-profile-brand">
          <div
            v-if="$hasKey(profile_data, 'user.profile.address')"
            class="location-data"
          >
            <span>{{ profile_data.user.profile.address | validate }}</span>
          </div>
          <div class="contact-data">
            <span v-if="$hasKey(profile_data, 'user.profile.phone')">{{
              profile_data.user.profile.phone | validate
            }}</span>
            <span
              v-if="$hasKey(profile_data, 'user.profile.phone')"
              class="separator"
              >|</span
            >
            <span v-if="$hasKey(profile_data, 'user.email')">{{
              profile_data.user.email | validate
            }}</span>
          </div>
          <div
            class="decr"
            v-if="$hasKey(profile_data, 'user.profile.description')"
            v-html="profile_data.user.profile.description"
          ></div>
          <div class="description-option" v-else>
            <a href="#add" @click.prevent="editProfile">Add Description</a>
          </div>
          <div class="consultant-profile-option">
            <app-dialog
              title="Download CV"
              ask="Do you want to export your CV?"
              yesText="Export CV"
              noText="Cancel"
              yesBtnClass="btn-default"
              @onComfirm="showExport = true"
            >
              <button class="btn-export-cv">Export CV</button>
            </app-dialog>
            <export-cv
              :visible="showExport"
              :names="
                profile_data.user.first_name + ' ' + profile_data.user.last_name
              "
              @onClose="showExport = false"
            />
            <button class="edit-btn" @click="editProfile">Edit Profile</button>
          </div>
          <p v-if="$hasKey(profile_data, 'user.profile.available_from')">
            Available from
            {{
              profile_data.user.profile.available_from | formatDate | validate
            }}
          </p>
        </div>
        <div class="consultant-profile-options"></div>
      </div>

      <div class="consultant-profile-body">
        <ul class="project-items" v-if="profile_data.projects.length > 0">
          <li class="project-starter">
            <div class="project-item-header">
              <label
                >Project ({{
                  profile_data.projects.slice(0, 5).length | validate
                }})</label
              >
            </div>
          </li>
          <li
            class="project-item"
            v-for="(item, i) in profile_data.projects.slice(0, 5)"
            :key="i"
          >
            <panel-expand :expand="false">
              <template v-slot:header>
                <div class="project-item-header">
                  <div class="project-item-brand">
                    <img src="@/assets/icons/projects_icon.svg" alt />
                  </div>
                  <div class="content">
                    <div class="title-row">
                      <label>{{ item.name | validate }}</label>
                      <span v-if="item.address">{{
                        item.address | validate
                      }}</span>

                      <span class="date">
                        <span v-if="item.from">{{
                          item.from | formatDate | validate
                        }}</span>
                        <span class="separator" v-if="item.from && item.to"
                          >-</span
                        >
                        <span v-if="item.to">{{
                          item.to | formatDate | validate
                        }}</span>
                      </span>
                    </div>
                    <div class="options">
                      <div class="btns"></div>
                      <span v-if="item.verified" class="verified-status"
                        >Verified</span
                      >
                    </div>
                  </div>
                </div>
              </template>
            </panel-expand>
          </li>
        </ul>
        <div class="empty-widget" v-else>
          <div class="empty-widgetheader">
            <label>Projects</label>
          </div>
          <div class="empty-widget-body">
            <p>You have not yet added any projects.</p>
          </div>
        </div>
      </div>
      <div class="consultant-profile-body">
        <ul class="skills-items">
          <li class="skills-starter">
            <div class="skills-item-header">
              <label>Skills</label>
            </div>
          </li>
        </ul>
        <div class="skills-widget">
          <div class="skills_content__wrapper">
            <!-- Tools -->
            <div class="skill_box">
              <div class="skill_box_header">
                <label>Tools</label>
              </div>
              <div
                class="skill_box_body"
                v-if="profile_data.skills.tools.length > 0"
              >
                <div
                  class="row__item"
                  v-for="(item, i) in profile_data.skills.tools.slice(0, 5)"
                  :key="i"
                >
                  <span>{{ item.name | validate }}</span>
                  <star-rating
                    inactive-color="#C1C1C1"
                    :read-only="true"
                    active-color="#1BA5A4"
                    :star-size="14"
                    :show-rating="false"
                    v-model="item.priority"
                  ></star-rating>
                </div>
              </div>
              <div class="skill_box_body" v-else>
                <div class="empty-skills">
                  <p>You have not added any tool yet</p>
                </div>
              </div>
            </div>
            <!-- Compentence -->
            <div class="skill_box">
              <div class="skill_box_header">
                <label>Competences</label>
              </div>
              <div
                class="skill_box_body"
                v-if="profile_data.skills.competences.length > 0"
              >
                <div
                  class="row__item"
                  v-for="(item, i) in profile_data.skills.competences.slice(
                    0,
                    5
                  )"
                  :key="i"
                >
                  <span>{{ item.name | validate }}</span>
                  <star-rating
                    inactive-color="#C1C1C1"
                    :read-only="true"
                    active-color="#1BA5A4"
                    :star-size="14"
                    :show-rating="false"
                    v-model="item.priority"
                  ></star-rating>
                </div>
              </div>
              <div class="skill_box_body" v-else>
                <div class="empty-skills">
                  <p>You have not added any competence yet</p>
                </div>
              </div>
            </div>
            <!-- Role -->
            <div class="skill_box">
              <div class="skill_box_header">
                <label>Roles</label>
              </div>
              <div
                class="skill_box_body"
                v-if="profile_data.skills.roles.length > 0"
              >
                <div
                  class="row__item"
                  v-for="(item, i) in profile_data.skills.roles.slice(0, 5)"
                  :key="i"
                >
                  <span>{{ item.name | validate }}</span>
                  <star-rating
                    inactive-color="#C1C1C1"
                    :read-only="true"
                    active-color="#1BA5A4"
                    :star-size="14"
                    :show-rating="false"
                    v-model="item.priority"
                  ></star-rating>
                </div>
              </div>
              <div class="skill_box_body" v-else>
                <div class="empty-skills">
                  <p>You have not added any role</p>
                </div>
              </div>
            </div>
          </div>
          <div class="next_skills_content__wrapper">
            <!-- Domain -->
            <div class="skill_box">
              <div class="skill_box_header">
                <label>Domains</label>
              </div>
              <div
                class="skill_box_body"
                v-if="profile_data.skills.domains.length > 0"
              >
                <div
                  class="row__item"
                  v-for="(item, i) in profile_data.skills.domains.slice(0, 5)"
                  :key="i"
                >
                  <span>{{ item.name | validate }}</span>
                  <star-rating
                    inactive-color="#C1C1C1"
                    :read-only="true"
                    active-color="#1BA5A4"
                    :star-size="14"
                    :show-rating="false"
                    v-model="item.priority"
                  ></star-rating>
                </div>
              </div>
              <div class="skill_box_body" v-else>
                <div class="empty-skills">
                  <p>You have not added any domain yet</p>
                </div>
              </div>
            </div>
            <!-- Language -->
            <div class="skill_box">
              <div class="skill_box_header">
                <label>Languages</label>
              </div>
              <div
                class="skill_box_body"
                v-if="profile_data.skills.languages.length > 0"
              >
                <div
                  class="row__item"
                  v-for="(item, i) in profile_data.skills.languages.slice(0, 5)"
                  :key="i"
                >
                  <span>{{ item.lang.name | validate }}</span>
                  <star-rating
                    inactive-color="#C1C1C1"
                    :read-only="true"
                    active-color="#1BA5A4"
                    :star-size="14"
                    :show-rating="false"
                    v-model="item.level"
                  ></star-rating>
                </div>
              </div>
              <div class="skill_box_body" v-else>
                <div class="empty-skills">
                  <p>You have not added any language yet</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dropdownMenu from "@/components/Partials/dropdownMenu";
import appDialog from "@/components/Dialog/AppDialog.vue";
import panelExpand from "@/components/Partials/panelExpand";
import consultfiedButton from "@/components/helper/consultfiedButton.vue";
import Datepicker from "vuejs-datepicker";
import HtmlEditor from "@/components/helper/HtmlEditor.vue";
import { mapGetters } from "vuex";
import { eventBus } from "@/main";
import ExportCv from "@/components/Dialog/ExportCv.vue";

export default {
  name: "PublicInfo",
  components: {
    dropdownMenu,
    appDialog,
    panelExpand,
    HtmlEditor,
    Datepicker,
    consultfiedButton,
    ExportCv,
  },
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  data: () => {
    return {
      showExport: false,
      profile_data: {
        projects: [],
        skills: {
          tools: [],
          domains: [],
          languages: [],
          competences: [],
          roles: [],
        },
        employment: [],
        educations: [],
        trainings: [],
        certifications: [],
        tags: [],
        notifications: [],
        user: {},
        profile: {},
      },
    };
  },
  mounted() {
    let vm = this;
    vm.getProfileData();
  },
  computed: {},
  methods: {
    editProfile() {
      this.$router.push({ name: "settings" });
    },
    processSkills(skills_data) {
      let skills = {
        tools: [],
        domains: [],
        languages: [],
        competences: [],
        roles: [],
      };
      if (skills_data && skills_data.length > 0) {
        skills_data.forEach((skill) => {
          skill.tools.forEach((item) => {
            let obj = {
              name: item.name,
              priority: item.priority,
              level: parseInt(item.priority),
            };
            skills.tools.push(obj);
          });
          skill.domains.forEach((item) => {
            let obj = {
              name: item.name,
              priority: item.priority,
              level: parseInt(item.priority),
            };
            skills.domains.push(obj);
          });
          skill.competences.forEach((item) => {
            let obj = {
              name: item.name,
              priority: item.priority,
              level: parseInt(item.priority),
            };
            skills.competences.push(obj);
          });
          skill.roles.forEach((item) => {
            let obj = {
              name: item.name,
              priority: item.priority,
              level: parseInt(item.priority),
            };
            skills.roles.push(obj);
          });
          skill.languages.forEach((item) => {
            if (item.lang) {
              let obj = {
                lang: { name: item.lang.name },
                level: parseInt(item.level),
              };
              skills.languages.push(obj);
            }
          });
        });
      }
      return skills;
    },
    getProfileData() {
      let vm = this;
      vm.$store.dispatch("GET_CONSULTANT_DATA").then((response) => {
        let data = response.data;
        vm.profile_data = data;
        eventBus.$set(vm.profile_data, "skills", vm.processSkills(data.skills));
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.public-info-wrapper {
  width: 100%;
  .consultant-profile-container {
    padding: 1px;
    .consultant-profile-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-direction: column;
      padding: 20px;
      border-radius: 5px;
      background: #ffffff;
      margin-bottom: 10px;
      .section-title {
        width: 100%;
        display: none;
        @media (min-width: 300px) and (max-width: 630px) {
          display: block;
          margin-bottom: 19px;
          font-weight: 800;
        }
      }
      .consultant-profile-brand {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        @media (min-width: 300px) and (max-width: 630px) {
          border: 1px solid #ddd;
          padding: 10px 11px;
        }
        .location-data {
          .separator {
            margin-right: 5px;
          }
        }
        .contact-data {
          margin: 11px 0px;
          .separator {
            margin: 0px 5px;
          }
        }
        img {
          width: 60px;
          height: 60px;
          object-fit: cover;
          margin-bottom: 10px;
          border-radius: 50%;
        }
        span {
          font-family: "AvenirBook";
          font-size: 14px;
          margin-bottom: 10px;
        }
        p {
          text-align: center;
          font-size: 14px;
          line-height: 20px;
          font-family: "AvenirBook";
          margin: 10px 50px 10px 50px;
        }
        .consultant-profile-option {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          .btn-export-cv {
            background: #1885ad 0% 0% no-repeat padding-box;
            border: none;
            border-radius: 5px;
            padding: 10px 18px;
            font-size: 14px;
            margin-top: 13px;
            color: #fff;
            cursor: pointer;
            outline: none;
            width: 180px;
            margin-right: 20px;
            font-family: "AvenirBook";
            text-decoration: none;
            text-align: center;
          }
          .edit-btn {
            background: #ffffff 0% 0% no-repeat padding-box;
            border: none;
            border-radius: 5px;
            padding: 10px 18px;
            font-size: 14px;
            margin-top: 13px;
            color: #646262;
            cursor: pointer;
            outline: none;
            width: 180px;
            font-family: "AvenirBook";
            border: 1px solid #ccc;
          }
        }
      }
      .consultant-profile-options {
        .btn-edit-info {
          box-shadow: 0px 1px 3px #00000029;
          border: 1px solid #36adae;
          border-radius: 5px;
          color: #1885ad;
          padding: 10px 50px;
          font-family: "AvenirBook";
        }
      }
    }

    .consultant-profile-body {
      padding: 20px;
      border-radius: 5px;
      background: #ffffff;
      margin-bottom: 20px;
      ul.project-items {
        padding-left: 0px;
        list-style: none;
        .project-starter {
          margin-bottom: 6px;
          .project-item-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 0px;
            label {
              color: #000000;
              font-family: "AvenirBook";
              font-size: 16px;
            }
            .btn-add-assignment {
              color: #1ba5a4;
              border: none;
              padding: 10px 10px;
              font-size: 14px;
              outline: none;
              cursor: pointer;
              font-family: "AvenirBook";
              font-style: italic;
              background: transparent;
            }
          }
          p {
            color: #131313;
            font-family: "AvenirBook";
          }
        }
        .project-item {
          background: #f5f5f5 0% 0% no-repeat padding-box;
          border-radius: 5px;
          margin-bottom: 10px;
          .project-item-header {
            display: grid;
            padding: 17px 17px;
            grid-template-columns: 90px calc(98% - 90px);
            grid-column-gap: 20px;
            @media (min-width: 300px) and (max-width: 630px) {
              grid-template-columns: 100%;
              padding: 10px 12px;
            }
            .project-item-brand {
              display: flex;
              justify-content: center;
              align-items: center;
              width: 90px;
              height: 90px;
              background: rgb(228, 228, 228);
              border-radius: 50%;
              margin-right: 15px;
              @media (min-width: 300px) and (max-width: 630px) {
                width: 60px;
                height: 60px;
                display: none;
              }
              img {
                width: 50px;
                height: 50px;
                object-fit: cover;
                @media (min-width: 300px) and (max-width: 630px) {
                  width: 33px;
                  height: 33px;
                }
              }
            }
            .content {
              display: flex;
              justify-content: space-between;

              .title-row {
                font-family: "AvenirBook";
                padding-right: 9px;
                display: flex;
                flex-direction: column;
                justify-content: center;

                label {
                  display: block;
                  font-size: 14px;
                  font-family: "AvenirBlack";
                  margin-bottom: 1px;
                  font-weight: 800;
                  @media (min-width: 300px) and (max-width: 630px) {
                    font-size: 12px;
                  }
                }

                span {
                  color: #808080;
                  font-family: "AvenirBook";
                  font-size: 13px;
                  margin-bottom: 6px;
                  @media (min-width: 300px) and (max-width: 630px) {
                    font-size: 12px;
                  }
                }
                .date {
                  color: #808080;
                  font-family: "AvenirBook";
                  font-size: 13px;
                  display: flex;
                  justify-content: flex-start;
                  width: 100%;
                  align-items: center;
                  span {
                    margin-bottom: 0px;
                  }
                  .separator {
                    margin: 0px 5px;
                  }
                  @media (min-width: 300px) and (max-width: 630px) {
                    span {
                      font-size: 11px;
                    }
                  }
                }
              }
              .options {
                display: flex;
                align-items: flex-end;
                flex-direction: column;
                .btns {
                  display: flex;
                  margin-top: -11px;
                }
                .verified-status {
                  color: #0590ab;
                  margin: 10px 0px;
                }
                .btn-verify {
                  height: 40px;
                  width: 100px;
                  outline: none;
                  color: #fff;
                  background-color: #1890a9;
                  border-radius: 5px;
                }

                .status {
                  color: #000;
                  font-family: "AvenirBook";
                  font-size: 13px;
                }

                .toogle-panel-btn {
                  width: 19px;
                  padding: 0;
                  height: 22px;
                  font-size: 20px;
                  position: absolute;
                  bottom: 5px;
                  right: 7px;
                }
              }
            }
            .toogle-panel-btn {
              padding: 1px 40px;
              font-size: 30px;
              background: transparent;
              border: none;
              outline: none;
              cursor: pointer;
              color: #ccc;
            }
          }
          .project-item-body {
            padding: 10px;
            h4 {
              font-family: "AvenirBook";
            }
            img {
              width: 100%;
            }
            p {
              font-size: 14px;
              font-family: "AvenirBook";
            }
            label {
              color: #808080;
              font-size: 15px;
              display: block;
              margin-bottom: 8px;
              font-family: "AvenirBook";
            }
            .skills-widget {
              display: flex;
              flex-wrap: wrap;
              .skill-item {
                background: #707070 0% 0% no-repeat padding-box;
                border-radius: 25px;
                color: #ffffff;
                font-size: 13px;
                font-family: "AvenirBook";
                padding: 5px 22px;
                margin-right: 10px;
                margin-bottom: 10px;
              }
            }
            .project-info {
              display: flex;
              justify-content: space-between;
              margin-top: 20px;
              .col-one,
              .col-two {
                width: 50%;
                label {
                  color: #808080;
                  margin-bottom: 3px;
                  margin-top: 20px;
                }
                p {
                  color: #000;
                  margin: 0px;
                }
              }
            }
          }
        }
      }
      .empty-widget {
        .empty-widget-body {
          height: 350px;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          h1 {
            margin-bottom: 30px;
          }
          p {
            text-align: center;
            width: 270px;
          }
          .add-btn {
            width: 180px;
            height: 45px;
            background: #1890a9 0% 0% no-repeat padding-box;
            border-radius: 4px;
            color: #fff;
            outline: none;
            margin-right: 20px;
            display: center;
            justify-content: center;
          }
        }
      }
    }
    .consultant-profile-body {
      padding: 20px;
      border-radius: 5px;
      background: #ffffff;
      margin-bottom: 20px;
      ul.skills-items {
        padding-left: 0px;
        list-style: none;
        .skills-starter {
          margin-bottom: 6px;
          .skills-item-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 16px 0px;
            label {
              color: #000000;
              font-family: "AvenirBook";
              font-size: 16px;
            }
          }
        }
      }
      .skills-widget {
        .skills_content__wrapper {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          grid-column-gap: 10px;
          margin-bottom: 10px;
          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 1fr;
          }
          .skill_box {
            min-width: 0;
            display: flex;
            flex-direction: column;
            width: 100%;
            background: #f5f5f5;
            border-radius: 5px;
            margin-bottom: 15px;
            .skill_box_header {
              border-bottom: 2px solid #fff;
              height: 50px;
              display: flex;
              align-items: center;
              justify-content: space-around;
              padding: 0px 15px;
              label {
                color: #0884af;
                width: 100%;
                font-size: 15px;
                font-weight: 800;
              }
            }
            .skill_box_body {
              padding: 0px 15px;
              .empty-skills {
                display: flex;
                flex-direction: column;
                align-items: center;
                height: 200px;
                justify-content: center;
                p {
                  text-align: center;
                  margin-bottom: 20px;
                  color: #8d8d8d;
                }
                button {
                  width: 133px;
                  height: 36px;
                  background: #1890a9 0% 0% no-repeat padding-box;
                  border-radius: 5px;
                  color: #fff;
                }
              }
              .row__item {
                margin-top: 10px;
                display: flex;
                margin-bottom: 10px;
                justify-content: space-between;
                width: 100%;
                span {
                  color: #000000;
                  font-weight: normal;
                  margin-top: 2px;
                  font-size: 14px;
                }
              }
            }
          }
        }
        .next_skills_content__wrapper {
          display: grid;
          grid-template-columns: 1fr 1fr;
          grid-column-gap: 10px;
          @media (min-width: 300px) and (max-width: 630px) {
            grid-template-columns: 1fr;
          }
          .skill_box {
            min-width: 0;
            display: flex;
            flex-direction: column;
            width: 100%;
            background: #f5f5f5;
            border-radius: 5px;
            margin-bottom: 15px;
            .skill_box_header {
              border-bottom: 2px solid #fff;
              height: 50px;
              display: flex;
              align-items: center;
              justify-content: space-around;
              padding: 0px 15px;
              label {
                color: #0884af;
                width: 100%;
                font-size: 15px;
                font-weight: 800;
              }
            }
            .skill_box_body {
              padding: 0px 15px;
              .empty-skills {
                display: flex;
                flex-direction: column;
                align-items: center;
                height: 200px;
                justify-content: center;
                p {
                  text-align: center;
                  margin-bottom: 20px;
                  color: #8d8d8d;
                }
                button {
                  width: 133px;
                  height: 36px;
                  background: #1890a9 0% 0% no-repeat padding-box;
                  border-radius: 5px;
                  color: #fff;
                }
              }
              .row__item {
                margin-top: 10px;
                display: flex;
                margin-bottom: 10px;
                justify-content: space-between;
                width: 100%;
                span {
                  color: #000000;
                  font-weight: normal;
                  margin-top: 2px;
                  font-size: 14px;
                }
              }
            }
          }
        }
      }
    }
  }
  .edit-user-info-modal {
    position: fixed;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    background: rgba(0, 0, 0, 0.5);
    z-index: 999999999999999999999999999;
    display: flex;
    justify-content: center;
    padding-top: 90px;
    overflow-y: auto;
    .edit-user-info-form {
      width: 700px;
      background: #fff;
      border-radius: 5px;
      padding: 30px;
      display: inline-table;
      .input-group {
        margin-bottom: 20px;
        label {
          display: block;
          margin: 10px;
          margin-left: 0px;
        }
        .date-time {
          display: flex;
          .input {
            height: 40px;
            border: 1px solid #ddd;
            padding: 0px 20px;
          }
        }
      }
      .__btns {
        display: flex;
        width: 30%;
        margin-top: 30px;
        justify-content: space-between;
        .btn-cancel {
          color: #1ba5a4;
          cursor: pointer;
          font-weight: normal;
          height: 40px;
          padding: 3px 20px;
          font-size: 14px;
          width: 100px;
        }
        .btn-save {
          background: #1ba5a4;
          color: #fff;
          font-size: 14px;
          font-weight: normal;
          cursor: pointer;
          border-radius: 5px;
          height: 40px;
          width: 100px;
          padding: 3px 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          &:disabled {
            background: #8d8d8d;
            opacity: 0.3;
          }
        }
      }
    }
  }
}
</style>